module.exports = __webpack_public_path__ + "static/media/I Quaff the Fog Juice-30sec.3f613b38.mp3";